import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static classes = ["entering", "enteringFrom", "enteringTo", "leaving", "leavingFrom", "leavingTo"];

  static values = {
    enterDuration: Number,
    leaveDuration: Number,
    autoCloseDelay: Number,
  };

  connect() {
    console.log(this);
    this.open();
  }

  open() {
    setTimeout(() => {
      this.element.classList.remove(...this.enteringFromClasses);
      this.element.classList.add(...this.enteringToClasses);
      this.element.classList.remove(...this.enteringClasses);

      setTimeout(() => {
        this.close();
      }, this.autoCloseDelayValue);
    }, this.enterDurationValue);
  }

  close() {
    this.element.classList.remove(...this.enteringToClasses);
    this.element.classList.add(...this.leavingClasses);
    this.element.classList.add(...this.leavingFromClasses);

    setTimeout(() => {
      this.element.classList.add(...this.leavingToClasses);
      this.element.classList.remove(...this.leavingFromClasses);
      this.element.remove();
    }, this.leaveDurationValue);
  }
}
